// index.tsx - Updated to handle WebSocket integration
import { Save } from 'lucide-react';
import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import classes from './overrideCapture.module.scss';
import { useOverridecapture } from './useOverrideCapture';

interface OverrideCaptureModalProps {
  sendActiveUserUpdate: (roomId: string, action: 'add' | 'remove') => void;
  isConnected: boolean;
}

const OverrideCaptureModal = ({ sendActiveUserUpdate, isConnected }: OverrideCaptureModalProps) => {
  // Call the hook with WebSocket parameters for proper user removal timing
  const { visibility, onClose, items, updateReason, isValid, handleSave, isLoading } =
    useOverridecapture(sendActiveUserUpdate, isConnected);

  const renderFooter = () => {
    return (
      <div className={classes.actionFooter}>
        <Button
          label="Save"
          className={classes.saveButton}
          onClick={handleSave}
          disabled={!isValid() || isLoading}
          icon={
            isLoading ? (
              <ProgressSpinner
                style={{ width: '25px', height: '25px' }}
                strokeWidth="8"
                animationDuration="1s"
                className={classes.saveIcon}
              />
            ) : (
              <Save className={classes.saveIcon} style={{ marginRight: '0.2rem' }} />
            )
          }
        />
      </div>
    );
  };

  return (
    <Dialog
      header="Reason Capture"
      visible={visibility}
      onHide={onClose}
      className={classes.modal}
      style={{ width: '750px' }}
      footer={renderFooter()}
    >
      <div className={classes.tableContainer}>
        <table className={classes.table}>
          <thead>
            <tr>
              <th>Job id</th>
              <th>Action</th>
              <th>Value</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={`${item.jobId}-${item.action}-${item.valueBefore}-${item.valueNow}`}>
                <td>{item.jobId}</td>
                <td>{item.action}</td>
                <td>
                  <div className={classes.valueCell}>
                    <span className={classes.valueBefore}>{item.valueBefore}</span>
                    <span className={classes.valueArrow}>→</span>
                    <span className={classes.valueNow}>{item.valueNow}</span>
                  </div>
                </td>
                <td>
                  <InputText
                    className={classes.reasonInput}
                    value={item.reason}
                    onChange={e => updateReason(index, e.target.value)}
                    placeholder="Enter reason"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Dialog>
  );
};

export default observer(OverrideCaptureModal);
